import { useNavigate } from "react-router-dom";
import { useTheme } from "../../../../components/hooks/useTheme";
import { useState } from "react";
import colorConfigs from "../../../../configs/colorConfigs";
import { AllRelocationMapping } from "./AllRelocationMapping";

const filterItems = [
    {
        id: 0,
        label: "From Location",
    },
    {
        id: 1,
        label: "To Location",
    },
    {
        id: 2,
        label: "From Vehicle Class",
    },
    {
        id: 3,
        label: "To Vehicle Class",
    },
]

export const RelocationMapping = () => {
    const { themeStyles } = useTheme();
    const navigate = useNavigate();
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10,
    });
    const [searchValue, setSearchValue] = useState<string>("");
    const [relocationMappingFilterValue, setRelocationMappingFilterValue] = useState(0);
    const [selectedFilter, setSelectedFilter] = useState<string>(filterItems[0].label);

    return (
        <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
            <div className={`w-full ${themeStyles.main.tailwindMainBg} border ${themeStyles.main.borderColor} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
                <div className="flex items-center justify-end">
                    <div className="flex items-center gap-2.5">
                        <button className={`px-[8px] py-[6px] ${colorConfigs.btn.main.tailwind} rounded-lg border ${themeStyles.main.borderColor} text-white flex items-center gap-1.5`}
                            onClick={() => navigate("/admin/fleet/relocationMapping/addrelocationMapping")}
                        >
                            <span className="material-symbols-outlined text-[25px] font-light">
                                add
                            </span>
                            <span className="text-xs font-medium">Relocation Mapping</span>
                        </button>
                    </div>
                </div>


                <div>
                    <AllRelocationMapping
                        paginationModel={paginationModel}
                        setPaginationModel={setPaginationModel}
                        searchValue={searchValue}
                        setSearchValue={setSearchValue}
                        relocationMappingFilterValue={relocationMappingFilterValue}
                        setRelocationMappingFilterValue={setRelocationMappingFilterValue}
                        selectedFilter={selectedFilter}
                        setSelectedFilter={setSelectedFilter}
                        filterItems={filterItems}
                    />
                </div>
            </div>
        </div>
    )
}